/* vim :set sw=2: */

/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable no-console */
/* eslint-disable space-infix-ops */
/* eslint-disable no-constant-condition */
/* eslint-disable no-else-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
/* eslint-disable no-loop-func */

import WallspiceWebgl from "Renderer/WallspiceWebgl"
import { getFloorPlane } from "Renderer/SceneUtils"
import { WALL_SHIFT } from "Renderer/constants"

const useDebugView = false

function
rotMat(a)
{
  return [
    [ +Math.cos(a), -Math.sin(a) ],
    [ +Math.sin(a), +Math.cos(a) ]
  ]
}

function
debugConnect()
{
  if( ! useDebugView )
    return

  if( ! window.wallSnapDebugWS )
  {
    window.wallSnapDebugWSConnected = false
    window.wallSnapDebugWSQueue = []

    window.wallSnapDebugWS = new WebSocket("ws://localhost:8080")

    window.wallSnapDebugWS.onerror = (
      err =>
      {
        console.log("WS ERROR --------------")
        console.log(err)
        window.wallSnapDebugWS = new WebSocket("ws://localhost:8080")
      }
    )

    window.wallSnapDebugWS.onopen = (
      () =>
      {
        console.log("WS OPEN --------------")

        window.wallSnapDebugWSConnected = true

        window.wallSnapDebugWSQueue.forEach(msg => {
          window.wallSnapDebugWS.send(msg)
        })

        window.wallSnapDebugWSQueue = null
      }
    )
  }
}

function
debugSend(msg)
{
  if( ! useDebugView )
    return

  debugConnect()

  const msgJSON = JSON.stringify(msg)

  if( window.wallSnapDebugWSConnected )
    window.wallSnapDebugWS.send(msgJSON)
  else
    window.wallSnapDebugWSQueue.push(msgJSON)
}

function
sendFloorLines(lines)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "lines",
    lines
  })
}

function
debugFrame()
{
  if( ! useDebugView )
    return

  debugSend({
    type: "frame"
  })
}

function
debugIter()
{
  if( ! useDebugView )
    return

  debugSend({
    type: "iter"
  })
}

function
debugContactsOrig(csOrig)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "contactsOrig",
    contactsOrig: csOrig
  })
}

function
debugContacts(cs)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "contacts",
    contacts: cs
  })
}

function
debugNormalShifts(shifts)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "normalShifts",
    shifts
  })
}

function
debugGood(good)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "good",
    good
  })
}

function
debugBody(body)
{
  if( ! useDebugView )
    return

  const pos = [
    body.pos[0],
    body.pos[1]
  ]

  const m = rotMat(body.rot)

  const corners = []

  for(let i = 0; i < body.corners.length; i++)
  {
    let q = body.corners[i]

    q = [
      pos[0] + m[0][0] * q[0] + m[0][1] * q[1],
      pos[1] + m[1][0] * q[0] + m[1][1] * q[1]
    ]

    corners.push(q)
  }

  debugSend({
    type: "body",
    corners
  })
}

function
debugMouseForce(mf)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "mouseForce",
    mouseForce: mf
  })
}

function
debugForceIter(cs, fs)
{
  if( ! useDebugView )
    return

  debugSend({
    type: "forceIter",
    contacts: cs,
    forces: fs
  })
}

function
bake(renderItem, xy, orientation)
{
  const ri = renderItem
  const renderer = ri.Renderer
  const intrinsics = renderer.intrinsics
  const planes = renderer.manifest.plane_orientation_0.planeData
  const floor = getFloorPlane(planes)

  const floorPoint = WallspiceWebgl.screenToPlaneWorld(
    ri.position, floor, intrinsics
  )

  ri.position = xy
  ri.orientation = orientation

  ri.pose = {
    pos: floorPoint,
    rot: floor.rot
  }
}

function
intersectLines(a0, a1, b0, b1)
{
  const na = [
    -(a1[1] - a0[1]),
    +(a1[0] - a0[0])
  ]

  const nb = [
    -(b1[1] - b0[1]),
    +(b1[0] - b0[0])
  ]

  const a = na[0]
  const b = na[1]
  const c = -(a0[0] * na[0] + a0[1] * na[1])

  const d = nb[0]
  const e = nb[1]
  const f = -(b0[0] * nb[0] + b0[1] * nb[1])

  const det = a * e - b * d

  if( det === 0 )
    return null

  const x = (b * f - c * e) / det
  const y = (c * d - a * f) / det

  let dot0
  let dot1

  const a0Len2 = a0[0] * a0[0] + a0[1] * a0[1]
  dot0 = x * a0[0] + y * a0[1]
  dot1 = a1[0] * a0[0] + a1[1] * a0[1]
  if( dot1 - a0Len2 === 0) return null
  const t = (dot0 - a0Len2) / (dot1 - a0Len2)

  const b0Len2 = b0[0] * b0[0] + b0[1] * b0[1]
  dot0 = x * b0[0] + y * b0[1]
  dot1 = b1[0] * b0[0] + b1[1] * b0[1]
  if( dot1 - b0Len2 === 0 ) return null
  const s = (dot0 - b0Len2) / (dot1 - b0Len2)

  if( t >= 0 && t <= 1 && s >= 0 && s <= 1 )
  {
    return [
      a0[0] + t * (a1[0] - a0[0]),
      a0[1] + t * (a1[1] - a0[1])
    ]
  }

  return null
}

export
function
initBody(ri, w, h)
{
  const body = {}

  body.rot = 0
  body.pos = [ 0, 0 ]
  body.lines = []
  body.normals = []
  body.corners = []
  body.mass = 20

  body.lines = [
    [ [ +w/2, +h/2 ], [ -w/2, +h/2 ] ],
    [ [ -w/2, +h/2 ], [ -w/2, -h/2 ] ],
    [ [ -w/2, -h/2 ], [ +w/2, -h/2 ] ],
    [ [ +w/2, -h/2 ], [ +w/2, +h/2 ] ],
  ]

  for(let i = 0; i < body.lines.length; i++)
  {
    const [ q0, q1 ] = body.lines[i]

    const n = [
      (q0[0] + q1[0]) / 2,
      (q0[1] + q1[1]) / 2
    ]

    const nLen = Math.sqrt(
      + n[0] * n[0]
      + n[1] * n[1]
    )

    n[0] /= nLen
    n[1] /= nLen

    body.normals.push(n)
  }

  body.area = w * h
  body.density = body.mass / body.area
  body.i = body.mass * (w * w + h * h) / 12

  body.corners = [
    [ +w/2, +h/2 ],
    [ -w/2, +h/2 ],
    [ -w/2, -h/2 ],
    [ +w/2, -h/2 ]
  ]

  body.radius = 0.5 * Math.sqrt(w * w + h * h)

  const renderer = ri.Renderer
  const planes = renderer.manifest.plane_orientation_0.planeData
  const floor = getFloorPlane(planes)

  const floorPoint = WallspiceWebgl.screenToPlaneWorld(
    ri.position, floor, ri.Renderer.intrinsics
  )

  body.rot = ri.orientation
  body.pos = WallspiceWebgl.worldToPlane(floor, floorPoint)

  return body
}

//
// fb: base force (from mouse)
// tb: base torque (from mouse)
// cs: contact points
// fs: forces on contact points
// dt: target timestep
// ds: maximum spatial jump
//

function
positionalOffsets(renderer, body, fb, tb, cs, fs, dt, ds)
{
  const fn = [ fb[0], fb[1] ]
  let tau = tb

  for(let i = 0; i < fs.length; i += 1)
  {
    const [ c, n ] = cs[i]
    const f = Math.abs(fs[i])

    const fx = f * n[0]
    const fy = f * n[1]

    fn[0] += fx
    fn[1] += fy

    const rho0 = [
      c[0] - body.pos[0],
      c[1] - body.pos[1]
    ]

    tau += rho0[0] * fy - rho0[1] * fx
  }

  const m = body.mass
  const ti = body.i

  const fMag = Math.sqrt(fn[0] * fn[0] + fn[1] * fn[1])
  const dtf = Math.sqrt(2 * m * ds / fMag)
  const dta = Math.sqrt(Math.abs(2 * ds / body.radius * ti / tau))

  let dts

  if( fMag === 0 && tau === 0 )
    dts = 0
  else if( fMag === 0 )
    dts = dta
  else if( tau === 0 )
    dts = dtf
  else
    dts = (dtf < dta) ? dtf : dta

  const dtr = Math.min(dt, dts)

  const dx = 0.5 * (fn[0] / m) * dtr * dtr
  const dy = 0.5 * (fn[1] / m) * dtr * dtr
  const da = 0.5 * (tau / ti) * dtr * dtr

  return [ dx, dy, da, dtr ]
}

function
floorLineSegs(floorLine)
{
  return [
    {
      points: [
        floorLine.points[0],
        floorLine.points[1]
      ],
      normal: floorLine.n2
    },
    {
      points: [
        floorLine.points[0],
        [
          floorLine.points[0][0] - 10000 * floorLine.n2[0],
          floorLine.points[0][1] - 10000 * floorLine.n2[1]
        ]
      ],
      normal: [
        -floorLine.t2[0],
        -floorLine.t2[1]
      ]
    },
    {
      points: [
        floorLine.points[1],
        [
          floorLine.points[1][0] - 10000 * floorLine.n2[0],
          floorLine.points[1][1] - 10000 * floorLine.n2[1]
        ]
      ],
      normal: [
        +floorLine.t2[0],
        +floorLine.t2[1]
      ]
    }
  ]
}

function
contactPoints(renderer, body, ds)
{
  const pos = [
    body.pos[0],
    body.pos[1]
  ]

  const m = rotMat(body.rot)

  const contacts = []

  for(let i = 0; i < body.corners.length; i++)
  {
    let q = body.corners[i]

    q = [
      pos[0] + m[0][0] * q[0] + m[0][1] * q[1],
      pos[1] + m[1][0] * q[0] + m[1][1] * q[1]
    ]

    let minDQY
    let jmin

    for(let j = 0; j < renderer.floorLines.length; j++)
    {
      const floorLine = renderer.floorLines[j]
      const segs = floorLineSegs(floorLine)

      for(let k = 0; k < segs.length; k++)
      {
        const ki = segs.length - k - 1
        const [ q0 ] = segs[ki].points
        const n = segs[ki].normal

        const dq = [
          q[0] - q0[0],
          q[1] - q0[1]
        ]

        const dqy = -(n[0] * dq[0] + n[1] * dq[1])

        if( dqy < 0 )
          break

        if( ki === 0 )
        {
          const i0 = (i > 0) ? (i - 1) : (body.corners.length - 1)
          const i1 = (i + 1) % body.corners.length

          let c0 = body.corners[i0]
          let c1 = body.corners[i1]

          c0 = [
            pos[0] + m[0][0] * c0[0] + m[0][1] * c0[1],
            pos[1] + m[1][0] * c0[0] + m[1][1] * c0[1]
          ]

          c1 = [
            pos[0] + m[0][0] * c1[0] + m[0][1] * c1[1],
            pos[1] + m[1][0] * c1[0] + m[1][1] * c1[1]
          ]

          const cp0 = intersectLines(q, c0, floorLine.points[0], floorLine.points[1])
          const cp1 = intersectLines(q, c1, floorLine.points[0], floorLine.points[1])

          if( ! cp0 && ! cp1 )
            break

          if( minDQY === undefined || dqy < minDQY )
          {
            minDQY = dqy
            jmin = j
          }
        }
      }
    }

    if( minDQY !== undefined )
    {
      contacts.push([
        q,
        [
          +renderer.floorLines[jmin].n2[0],
          +renderer.floorLines[jmin].n2[1]
        ],
        [
          0, jmin, i
        ]
      ])
    }
  }

  for(let k = 0; k < renderer.floorLines.length; k++)
  {
    const endpointContacts = []

    const floorLine = renderer.floorLines[k]

    for(let i = 0; i < floorLine.points.length; i++)
    {
      const q = floorLine.points[i]

      let t2
      if( i === 0 )
        t2 = [ -floorLine.t2[0], -floorLine.t2[1] ]
      else
        t2 = [ +floorLine.t2[0], +floorLine.t2[1] ]

      let dqys = []

      for(let j = 0; j < body.lines.length; j++)
      {
        const bn = body.normals[j]

        const n = [
          m[0][0] * bn[0] + m[0][1] * bn[1],
          m[1][0] * bn[0] + m[1][1] * bn[1]
        ]

        n[0] = -n[0]
        n[1] = -n[1]

        const bodyLine = body.lines[j]

        let a = bodyLine[0]

        a = [
          pos[0] + m[0][0] * a[0] + m[0][1] * a[1],
          pos[1] + m[1][0] * a[0] + m[1][1] * a[1]
        ]

        const dq = [
          q[0] - a[0],
          q[1] - a[1]
        ]

        const dqy = dq[0] * n[0] + dq[1] * n[1]

        dqys.push([j, dqy, n])
      }

      let isInside = true

      for(let z = 0; z < dqys.length; z++)
      {
        const dqy = dqys[z][1]

        if( dqy < 0 )
        {
          isInside = false
          break
        }
      }

      if( ! isInside )
        continue

      dqys = dqys.sort((a, b) => a[1] - b[1])

      let found = false

      for(let di = 0; di < dqys.length; di++)
      {
        const dqy = dqys[di][1]
        const n = dqys[di][2]

        if( dqy > 10 * ds )
          continue

        const nDotN2 = (
          + n[0] * floorLine.n2[0]
          + n[1] * floorLine.n2[1]
        )

        const nDotT2 = (
          + n[0] * t2[0]
          + n[1] * t2[1]
        )

        if( nDotN2 >= 0 && nDotT2 >= 0 )
        {
          endpointContacts.push([ q, n, [ 1, k, i, dqys[di][0] ]])
          found = true
          break
        }
      }

      if( ! found )
      {
        endpointContacts.push([
          q,
          dqys[0][2],
          [ 1, k, i, dqys[0][0] ]
        ])
      }
    }

    if( endpointContacts.length === 2 )
    {
      contacts.push([
        floorLine.points[0],
        [...floorLine.n2],
        [ 4, k, 0 ]
      ])

      contacts.push([
        floorLine.points[1],
        [...floorLine.n2],
        [ 4, k, 1 ]
      ])
    }
    else if( endpointContacts.length === 1 )
    {
      contacts.push(endpointContacts[0])
    }
  }

  return contacts
}

function
rotateAndShift(r, m, p)
{
  return [
    r[0] + m[0][0] * p[0] + m[0][1] * p[1],
    r[1] + m[1][0] * p[0] + m[1][1] * p[1]
  ]
}

function
rotate(m, p)
{
  return [
    m[0][0] * p[0] + m[0][1] * p[1],
    m[1][0] * p[0] + m[1][1] * p[1]
  ]
}

function
getIntersection(body, floorLine)
{
  const m = rotMat(body.rot)

  const bodyLines = [ 0, 1, 2, 3 ].map(
    i =>
    {
      const line = [
        rotateAndShift(body.pos, m, body.lines[i][0]),
        rotateAndShift(body.pos, m, body.lines[i][1])
      ]

      const normal = rotate(m, body.normals[i])

      return {
        line,
        normal,
        mid: [
          (line[0][0] + line[1][0]) / 2,
          (line[0][1] + line[1][1]) / 2
        ]
      }
    }
  )

  const floorLinePointsInside =
  (
    floorLine.points.filter(
      point =>
      {
        return bodyLines.every(
          ({ mid, normal }) =>
          {
            const dot = (
              + normal[0] * (point[0] - mid[0])
              + normal[1] * (point[1] - mid[1])
            )

            return dot < 0
          }
        )
      }
    )
  )

  const cps = bodyLines.map(
    ({ line }) =>
    {
      return intersectLines(
        line[0],
        line[1],
        floorLine.points[0],
        floorLine.points[1])
    }
  ).filter( x => !! x )

  if( cps.length > 2 )
    return { length: 0 }

  const points = cps.concat(floorLinePointsInside)

  if( points.length !== 2 )
    return { length: 0 }

  const dx = points[0][0] - points[1][0]
  const dy = points[0][1] - points[1][1]

  return { 
    length: Math.sqrt(dx * dx + dy * dy),
    points,
  }
}

function
determinant(m)
{
  if( m.length === 1 )
  {
    return m[0][0]
  }
  else if( m.length === 2 )
  {
    return m[0][0] * m[1][1] - m[0][1] * m[1][0]
  }
  else
  {
    return m[0].reduce(
      (r, e, i) =>
      {
        return r + (-1)**(i + 2) * e * determinant(
          m.slice(1).map(c => c.filter((_, j) => i !== j))
        )
      },
      0
    )
  }
}

//
// Solve a system of linear equations using Cramer's Rule.
//

function
cramer(A, x)
{
  const ret = []

  if( x.length === 0 )
    return ret

  const d0 = determinant(A)

  for(let i = 0; i < x.length; i++)
  {
    const AC = []
    for(let j = 0; j < A.length; j++)
      AC.push([...A[j]])

    for(let j = 0; j < A.length; j++)
      AC[j][i] = x[j]

    const d = determinant(AC)

    ret.push(d / d0)
  }

  return ret
}

export
function
populatefs(renderer, body, fb, tb, fs, cs)
{
  const mat = []

  for(let i = 0; i < cs.length; i++)
  {
    const row = []
    mat.push(row)

    row.push(0)
    for(let j = 0; j < cs.length; j++)
      row.push(0)
  }

  for(let i = 0; i < cs.length; i++)
  {
    const row = mat[i]

    const [ c, n ] = cs[i]

    const nx = n[0]
    const ny = n[1]

    const rho0 = [
      c[0] - body.pos[0],
      c[1] - body.pos[1]
    ]

    const thetaHatRho0 = [
      - rho0[1],
      + rho0[0]
    ]

    row[0] = (
      (
        fb[0] * nx + fb[1] * ny
      ) / body.mass
      +
      (
        tb * (thetaHatRho0[0] * nx + thetaHatRho0[1] * ny)
      ) / body.i
    )

    const z = (
      + thetaHatRho0[0] * nx
      + thetaHatRho0[1] * ny
    ) / body.i

    for(let j = 0; j < cs.length; j++)
    {
      const je = j + 1

      const [ cj, nj ] = cs[j]

      const rhoJ = [
        cj[0] - body.pos[0],
        cj[1] - body.pos[1]
      ]

      const niDotNJ = nx * nj[0] + ny * nj[1]

      const q = rhoJ[0] * nj[1] - rhoJ[1] * nj[0]

      row[je] = niDotNJ / body.mass + z * q
    }
  }

  const x = []
  for(let i = 0; i < mat.length; i++)
    x.push(-mat[i].shift())

  const res = cramer(mat, x)

  for(let i = 0; i < res.length; i++)
    fs[i] = res[i]
}

function
accels(renderer, body, fb, tb, fs, cs, mps)
{
  const ret = []

  const fn = [ fb[0], fb[1] ]
  let tau = tb

  for(let i = 0; i < fs.length; i++)
  {
    const [ c, n ] = cs[i]
    const f = Math.abs(fs[i])

    const fx = f * n[0]
    const fy = f * n[1]

    fn[0] += fx
    fn[1] += fy

    const rho0 = [
      c[0] - body.pos[0],
      c[1] - body.pos[1]
    ]

    tau += rho0[0] * fy - rho0[1] * fx
  }

  for(let i = 0; i < mps.length; i += 1)
  {
    const [ c, n ] = mps[i]

    const rho0 = [
      c[0] - body.pos[0],
      c[1] - body.pos[1]
    ]

    const thetaHatRho0 = [
      -rho0[1],
      +rho0[0]
    ]

    const a = [
      fn[0] / body.mass + thetaHatRho0[0] * tau / body.i,
      fn[1] / body.mass + thetaHatRho0[1] * tau / body.i
    ]

    const aOnN = a[0] * n[0] + a[1] * n[1]

    ret[i] = aOnN
  }

  return ret
}

function
normalShifts(renderer, body, fb, tb, fs, cs, mps, dt)
{
  const acs = accels(renderer, body, fb, tb, fs, cs, mps)
  const ret = []

  for(let i = 0; i < acs.length; i++)
    ret.push(0.5 * acs[i] * dt * dt)

  return ret
}

function
setPositionals(renderItem, xy, orientation)
{
  const ri = renderItem
  const renderer = ri.Renderer
  const intrinsics = renderer.intrinsics
  const planes = renderer.manifest.plane_orientation_0.planeData
  const floor = getFloorPlane(planes)

  if( xy )
  {
    const mWorld = WallspiceWebgl.screenToPlaneWorld(xy, floor, intrinsics)

    if( mWorld[2] >= 0 )
      return false
  }

  if( ! ri.body || ! renderer.floorLines )
  {
    let bxy = xy
    let borientation = orientation

    if( bxy === undefined || bxy === null )
      bxy = ri.position

    if( borientation === undefined || borientation === null )
      borientation = ri.orientation

    bake(ri, bxy, borientation)

    return true
  }

  if( xy )
  {
    const floorPoint = WallspiceWebgl.screenToPlaneWorld(
      xy, floor, ri.Renderer.intrinsics
    )

    ri.body.targetPos = WallspiceWebgl.worldToPlane(floor, floorPoint)
  }

  let targetPos = ri.body.targetPos
  if( ! targetPos )
    targetPos = ri.body.pos

  const targetOrientation = orientation

  debugFrame()

  const ds = 0.01
  const dtn = 1

  const hist = []

  for(let loopi = 0; loopi < 1000; loopi++)
  {
    debugIter()

    debugBody(ri.body)

    const dp = [
      targetPos[0] - ri.body.pos[0],
      targetPos[1] - ri.body.pos[1]
    ]

    const dpLen = Math.sqrt(
      + dp[0] * dp[0]
      + dp[1] * dp[1]
    )

    if( dpLen > 0 )
    {
      dp[0] /= dpLen
      dp[1] /= dpLen
    }

    const fbMag = ri.body.mass * dpLen / (0.5 * dtn * dtn)

    const fb = [
      fbMag * dp[0],
      fbMag * dp[1]
    ]

    debugMouseForce(fb)

    let tb = 0

    if( targetOrientation )
    {
      const v0 = [
        Math.cos(ri.body.rot),
        Math.sin(ri.body.rot)
      ]

      const v1 = [
        Math.cos(targetOrientation),
        Math.sin(targetOrientation)
      ]

      const xHat = [ +v0[0], +v0[1] ]
      const yHat = [ -v0[1], +v0[0] ]

      const vx = v1[0] * xHat[0] + v1[1] * xHat[1]
      const vy = v1[0] * yHat[0] + v1[1] * yHat[1]

      const drot = Math.atan2(vy, vx)

      tb = ri.body.i * drot / (0.5 * dtn * dtn)

      fb[0] /= 10
      fb[1] /= 10
    }

    let cs = contactPoints(renderer, ri.body, ds)
    const csOrig = cs
    let fs = []

    for(let j = 0; j < cs.length; j++)
      fs.push(0)

    while(true)
    {
      populatefs(renderer, ri.body, fb, tb, fs, cs)

      debugForceIter(cs, fs)

      let remove
      let removeForce

      for(let i = 0; i < fs.length; i++)
      {
        if( fs[i] < 0 )
        {
          if( remove === undefined || fs[i] < removeForce )
          {
            remove = i
            removeForce = fs[i]
          }
        }
      }

      if( remove === undefined )
        break

      const newcs = []
      const newfs = []

      for(let i = 0; i < fs.length; i++)
      {
        if( i !== remove )
        {
          newcs.push(cs[i])
          newfs.push(0)
        }
      }

      cs = newcs
      fs = newfs
    }

    debugContactsOrig(csOrig)
    debugContacts(cs)

    const [ dx, dy, da, dt ] = positionalOffsets(
      renderer, ri.body, fb, tb, cs, fs, dtn, ds
    )

    const ns = normalShifts(
      renderer, ri.body, fb, tb, fs, cs, csOrig, dt
    )

    debugNormalShifts(ns)

    let good = true
    for(let nsi = 0; nsi < ns.length; nsi++)
    {
      if( ns[nsi] <= - ds * ds ) {
        good = false
        break
      }
    }

    debugGood(good)

    if( true
        && good
        && Number.isFinite(dx)
        && Number.isFinite(dy)
        && Number.isFinite(da) )
    {
      const d0 = Math.sqrt(dx * dx + dy * dy)
      const d1 = Math.abs(da) * ri.body.radius
      const d = (d0 > d1) ? d0 : d1

      if( d < 0.5 * ds * ds )
        break

      hist.push([
        ri.body.pos[0],
        ri.body.pos[1],
        ri.body.rot,
        da
      ])

      ri.body.pos[0] += dx
      ri.body.pos[1] += dy
      ri.body.rot += da

      const jitterThreshold = 10

      if( hist.length >= 2 * jitterThreshold )
      {
        let pos = 0
        let neg = 0

        for(let i = 0; i < 2 * jitterThreshold; i ++)
        {
          const v = hist[hist.length - 1 - i][3]

          if( v > 0 )
            pos += 1
          else if( v < 0 )
            neg += 1
        }

        if( pos === jitterThreshold && neg === jitterThreshold )
        {
          ri.body.pos[0] = hist[hist.length - 2 * jitterThreshold][0]
          ri.body.pos[1] = hist[hist.length - 2 * jitterThreshold][1]
          ri.body.rot = hist[hist.length - 2 * jitterThreshold][2]
          break
        }
      }
    }
    else
    {
      break
    }

    const screenPos = WallspiceWebgl.proj(
      WallspiceWebgl.planeToWorld(floor, ri.body.pos),
      intrinsics[0],
      intrinsics[1],
      intrinsics[2],
      intrinsics[3]
    )

    bake(ri, screenPos, ri.body.rot)
  }

  return true
}


//
// Pushes a renderItem away from any intersecting walls in the direction of a vector
// pointing from the intersection midpoint towards the item's center.
//

export
function
pushOut(ri)
{
  const ds = 0.01

  if( ! ri.body || ! ri.Renderer.floorLines )
    return

  let lines = [ ...ri.Renderer.floorLines ]

  let totalDist = 0
  while( lines.length > 0 && totalDist < 250 )
  {
    const linesAndIntersections = lines.map(
      line =>
      {
        return {
          line,
          intersection: getIntersection(ri.body, line)
        }
      }
    ).sort(
      (a, b) => b.intersection.length - a.intersection.length
    )

    if( linesAndIntersections[0].intersection.length <= 0 )
      break

    const { line, intersection } = linesAndIntersections.shift()

    const midp = [
      (intersection.points[0][0] + intersection.points[1][0]) / 2,
      (intersection.points[0][1] + intersection.points[1][1]) / 2,
    ]
    
    const dir = [
      ri.body.pos[0] - midp[0],
      ri.body.pos[1] - midp[1]
    ]

    const dot = line.n2[0] * dir[0] + line.n2[1] * dir[1]
    const sign = Math.sign(dot)

    let dist = 0
    const maxDist = 20

    while( dist < maxDist )
    {
      const { length } = getIntersection(ri.body, line)

      if( length <= 0 )
        break

      ri.body.pos[0] += ds * line.n2[0] * sign
      ri.body.pos[1] += ds * line.n2[1] * sign

      dist += ds
      totalDist += ds
    }

    lines = linesAndIntersections.map(
      lineAndIntersection => lineAndIntersection.line
    )
  }

  const renderer = ri.Renderer
  const intrinsics = renderer.intrinsics
  const planes = renderer.manifest.plane_orientation_0.planeData
  const floor = getFloorPlane(planes)

  const screenPos = WallspiceWebgl.proj(
    WallspiceWebgl.planeToWorld(floor, ri.body.pos),
      intrinsics[0],
      intrinsics[1],
      intrinsics[2],
      intrinsics[3]
  )

  bake(ri, screenPos, ri.body.rot)
}

export
function
setPosition(renderItem, xy)
{
  return setPositionals(renderItem, xy, null)
}

export
function
setOrientation(renderItem, newOrientation)
{
  return setPositionals(renderItem, null, newOrientation)
}

export
function
makeFloorLines(planes, maskData, intrinsics)
{
  const planePoints = []
  while( planePoints.length < planes.length )
    planePoints.push([])

  const extControlPoints = []
  while( extControlPoints.length < planes.length )
    extControlPoints.push([])

  const centroids = []
  while( centroids.length < planes.length )
    centroids.push([ 0, 0, 0 ])

  for(let y = 0; y < maskData.height; y += 1)
  {
    for(let x = 0; x < maskData.width; x += 1)
    {
      const idx = 4 * (y * maskData.width + x)

      const pixel = [
        maskData.data[idx + 0],
        maskData.data[idx + 1],
        maskData.data[idx + 2],
        maskData.data[idx + 3]
      ]

      const planeIndex = pixel[2] - 1

      if( planeIndex < 0 )
        continue

      const plane = planes[planeIndex]

      const worldPos = WallspiceWebgl.screenToPlaneWorld(
        [x, y],
        plane,
        intrinsics
      )

      planePoints[planeIndex].push(worldPos)

      if( x === 0 || x === maskData.width - 1 )
        extControlPoints[planeIndex].push(worldPos)
    }
  }

  const floor = getFloorPlane(planes)

  const fd = floor.d
  const fxh = floor.rot[0]
  const fyh = floor.rot[1]
  const fzh = floor.rot[2]

  const fcenter = [
    -fd * fzh[0],
    -fd * fzh[1],
    -fd * fzh[2]
  ]

  for(let i = 0; i < planePoints.length; i += 1)
  {
    const wall = planes[i]
    if( wall.class !== "wall" )
      continue

    const wallPoints = planePoints[i]
    if( wallPoints.length === 0 )
      continue

    const centroid = centroids[i]

    for(let j = 0; j < wallPoints.length; j += 1)
    {
      const p = wallPoints[j]

      centroid[0] += p[0] / wallPoints.length
      centroid[1] += p[1] / wallPoints.length
      centroid[2] += p[2] / wallPoints.length
    }
  }

  const lines = []

  for(let i = 0; i < planePoints.length; i += 1)
  {
    const wall = planes[i]
    if( wall.class !== "wall" )
      continue

    const wallPoints = planePoints[i]
    if( wallPoints.length === 0 )
      continue

    const wallExtControlPoints = extControlPoints[i]

    const wd = wall.d

    const wxh = wall.rot[0]
    const wyh = wall.rot[1]
    const wzh = wall.rot[2]

    const wcenter = [
      -wd * wzh[0],
      -wd * wzh[1],
      -wd * wzh[2]
    ]

    let right
    let left

    for(let j = 0; j < wallPoints.length; j += 1)
    {
      let p = wallPoints[j]

      p = [
        p[0] - wcenter[0],
        p[1] - wcenter[1],
        p[2] - wcenter[2]
      ]

      const px = (
        + p[0] * wxh[0]
        + p[1] * wxh[1]
        + p[2] * wxh[2]
      )

      left  = Math.min(left  || px, px)
      right = Math.max(right || px, px)
    }

    for(let j = 0; j < wallExtControlPoints.length; j += 1)
    {
      const ep = wallExtControlPoints[j]

      let dp = [
        ep[0] - centroids[i][0],
        ep[1] - centroids[i][1],
        ep[2] - centroids[i][2]
      ]

      const dpLen = Math.sqrt(
        + dp[0] * dp[0]
        + dp[1] * dp[1]
        + dp[2] * dp[2]
      )

      if( dpLen === 0 )
        continue

      dp[0] *= 1000 / dpLen
      dp[1] *= 1000 / dpLen
      dp[2] *= 1000 / dpLen

      dp = [
        dp[0] - wcenter[0],
        dp[1] - wcenter[1],
        dp[2] - wcenter[2]
      ]

      const px = (
        + dp[0] * wxh[0]
        + dp[1] * wxh[1]
        + dp[2] * wxh[2]
      )

      left  = Math.min(left  || px, px)
      right = Math.max(right || px, px)
    }

    const taus = []
    for(let j = 0; j < 2; j += 1)
    {
      const lambda = [left, right][j]

      const xip = [
        wcenter[0] + lambda * wxh[0],
        wcenter[1] + lambda * wxh[1],
        wcenter[2] + lambda * wxh[2]
      ]

      const nDotXIP = (
        + fzh[0] * xip[0]
        + fzh[1] * xip[1]
        + fzh[2] * xip[2]
      )

      const nDotYH = (
        + fzh[0] * wyh[0]
        + fzh[1] * wyh[1]
        + fzh[2] * wyh[2]
      )

      const tau = -(nDotXIP + fd) / nDotYH

      taus.push(tau)
    }

    const line = []
    for(let j = 0; j < 2; j += 1)
    {
      const tau = taus[j]
      const lambda = [left, right][j]

      let p = [
        wcenter[0] + lambda * wxh[0] + tau * wyh[0],
        wcenter[1] + lambda * wxh[1] + tau * wyh[1],
        wcenter[2] + lambda * wxh[2] + tau * wyh[2]
      ]

      p = [
        p[0] - fcenter[0],
        p[1] - fcenter[1],
        p[2] - fcenter[2]
      ]

      p = [
        fxh[0] * p[0] + fxh[1] * p[1] + fxh[2] * p[2],
        fyh[0] * p[0] + fyh[1] * p[1] + fyh[2] * p[2]
      ]

      line.push(p)
    }

    const dp = [
      line[1][0] - line[0][0],
      line[1][1] - line[0][1]
    ]

    const dpLen = Math.sqrt(
      + dp[0] * dp[0]
      + dp[1] * dp[1]
    )

    const tangent2D = [
      dp[0], dp[1]
    ]

    const normal2D = [
      dp[1], -dp[0]
    ]

    normal2D[0] /= dpLen
    normal2D[1] /= dpLen

    tangent2D[0] /= dpLen
    tangent2D[1] /= dpLen

    line[0][0] += WALL_SHIFT * normal2D[0]
    line[0][1] += WALL_SHIFT * normal2D[1]

    line[1][0] += WALL_SHIFT * normal2D[0]
    line[1][1] += WALL_SHIFT * normal2D[1]

    lines.push({
      points: line,
      n: wzh,
      n2: normal2D,
      t2: tangent2D,
      len: dpLen
    })
  }

  sendFloorLines(lines)

  return lines
}
